<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="front2"></a>
<a id="page_v"></a>
<h2 class="chaptertitle1">DRAMATIS PERSONAE</h2>
<p class="series01" id="front2_p1">Note that in Chinese the surname—here printed in capitals—precedes the personal name</p>
<p class="body-text01" id="front2_p2">
<i>The Morning of the Monkey:</i>
</p>
<p class="img" id="front2_p3">
<img alt="Images" height="210" src="images/v-1.jpg" width="453"/>
</p>
<p class="body-text01" id="front2_p4">
<i>The Night of the Tiger:</i>
</p>
<p class="img" id="front2_p5">
<img alt="Images" height="228" src="images/v-2.jpg" width="455"/>
</p>
<a id="page_vi"></a>
<p class="indent" id="front2_p6">In the accompanying Chinese zodiac—always represented with the south at the top—the images of the Monkey and the Tiger indicate their correct position; the other animals are represented by their cyclical signs only. The complete set, known as the Twelve Branches of Heaven*, consists of 1 Rat (Aries), 2 Cow (Taurus), 3 Tiger (Gemini), 4 Hare (Cancer), 5 Dragon (Leo), 6 Serpent (Virgo), 7 Horse (Libra), 8 Sheep (Scorpio), 9 Monkey (Sagittarius), 10 Cock (Capricorn), 11 Dog (Aquarius) and 12 Pig (Pisces). This series also indicates the 24 hours of a natural day: the Rat 11-1 a.m., the Cow 1-3 a.m., etc</p>
<p class="indent" id="front2_p7">A second cyclical series (not depicted here) consists of the ‘Ten Stems of Earth’, which represents also the Five Elements and the Five Planets, viz. I <i>chia</i>, II <i>yi</i> (both wood and Jupiter), III ping, IV <i>ting (fire</i> and Mars), V <i>mou</i>, VI <i>chi (earth</i> and Saturn), VII keng, VIII <i>hsin (metal</i> and Venus), IX Jen, X <i>kuei (water</i> and Mercury). The twelve ‘branches’, combined with the ten ‘stems’, form a sexagenary cycle: I-1, II-2, III-3, IV-4, V-5, VI-6, VII-7, VIII-8, IX-9, X-10, I-11, II-12, III-1, IV-2 and so on till X-12. This cycle of sixty double signs is the basis of Chinese chronology. Six cycles indicate the 360 days of a tropical year and ‘the twelve lunar months, and also the years themselves in an ever-repeating series of sixty—‘A cycle of Cathay’! The year 1900 was VII-1, a year of the Rat, and we are living now in the cycle that began in 1924 with the year of the Rat I-1; this particular cycle ends in 1984. The current year, 1965, is II-6, a year of the Serpent, 1966 will be III-7, a year of the Horse.</p>
<p class="indent" id="front2_p8">The octagonal design in the centre of the zodiac is explained in the Postscript</p>
<p class="img" id="front2_p9">
<a id="page_vii"></a>
<img alt="Images" height="417" src="images/vii-1.jpg" width="476"/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front2.vue?38644730